import React from 'react';

const LayoutDefault = ({ children }) => (
  <React.Fragment>
    <main className="site-content">
      {children}
    </main>
  </React.Fragment>
);

export default LayoutDefault;
